export default __webpack_public_path__ + "static/tanishq-518fee4aabe24105ff13829ee531a6c5.jpg";